import styled from 'styled-components';

import { TotemGallery } from 'components/TotemGallery';
import { PhotosInstructionFragmentFragment } from 'data/__generated__';

export const ColumnPhotosSection = ({
    instruction,
    title,
}: {
    instruction: PhotosInstructionFragmentFragment;
    title: string;
}) => {
    return (
        <Container>
            <Title>{title}</Title>
            <Content>
                <TotemGallery images={instruction.controlPhotos} />
            </Content>
        </Container>
    );
};

const Container = styled.div``;

const Content = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: bold;
    text-align: center;
`;
